import TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
// @ts-expect-error No types declared for Nabisco yet
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
export function get2faLoginObject(authMethod, twoFactorDao, usingHSPrompt) {
  let toBind = null;
  if (authMethod === TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR && usingHSPrompt) {
    toBind = twoFactorDao.loginWithHubspotApp;
  } else if (authMethod === TwoFactorAuthMethods.BACKUP) {
    toBind = twoFactorDao.tryTwoFactorBackupCode;
  } else {
    toBind = twoFactorDao.tryTwoFactor;
  }
  return new HubSpotOnlyAppCookieLogin({
    loginRequest: toBind.bind(twoFactorDao)
  });
}